module.exports = __webpack_public_path__ + "img/nagy-nora.1f459a66.jpg";